import { Fragment } from 'react';

import useExpandedRow from '@usas/ui-web/components/grids/UseExpandedRow';

import OrgUnitAdminPurchasesLargeGrid from './OrgUnitAdminPurchasesLargeGrid';
import OrgUnitAdminPurchasesSmallGrid from './OrgUnitAdminPurchasesSmallGrid';

const OrgUnitAdminPurchasesGrid = ({ gridData, isLoading, onDeletePurchaseItemDetailClicked }) => {
  const { onClick, expandedId } = useExpandedRow();
  return (
    <Fragment>
      <OrgUnitAdminPurchasesLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onClick={onClick}
        expandedId={expandedId}
        onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
      />
      <OrgUnitAdminPurchasesSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onClick={onClick}
        expandedId={expandedId}
        onDeletePurchaseItemDetailClicked={onDeletePurchaseItemDetailClicked}
      />
    </Fragment>
  )
};

export default OrgUnitAdminPurchasesGrid;